import BaseRating from 'common/components/base-rating';
import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import { colors } from 'common/constants';
import { Box, Typography } from '@mui/material';
import { common } from '@mui/material/colors';
import { useAppSelector } from 'common/hook';
interface IProps {
    name: string;
    defaultStar?: number;
    precision: number;
    options?: { id: number; label: string }[];
}
const QuestionScoreStar: React.FC<IProps> = ({
    name,
    defaultStar,
    precision,
    options,
}) => {
    const currentCampaign = useAppSelector(
        (state) => state.campaignState.campaign
    );
    const isCampaignPublicWithCode =
        currentCampaign?.kind === 'public_with_code';
    return (
        <Box>
            {options?.map((item, index) => {
                return (
                    <Box
                        key={index}
                        sx={{
                            marginBottom: [0.5, 2],
                            backgroundColor: [common.white, 'unset'],
                            padding: ['1rem', '0'],
                            opacity: 0.9,
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: [
                                    '1.2rem',
                                    '1.2rem',
                                    '1.2rem',
                                    '1.4rem',
                                    '1.4rem',
                                ],
                                marginBottom: [0.5, 1],
                                color: [colors.main, common.black],
                                fontWeight: [700, 500],
                                display: isCampaignPublicWithCode
                                    ? 'none'
                                    : 'block',
                            }}
                        >
                            {item.label}
                        </Typography>
                        <BaseRating
                            key={index}
                            name={`${name}.${index}.star`}
                            max={defaultStar}
                            size="large"
                            precision={precision}
                            defaultValue={0}
                            icon={
                                <StarIcon
                                    sx={{
                                        fontSize: ['3rem'],
                                    }}
                                />
                            }
                            emptyIcon={
                                <StarIcon
                                    sx={{
                                        fontSize: ['3rem'],
                                    }}
                                />
                            }
                            sx={{
                                width: ['100%', 'min-content'],
                                justifyContent: ['space-between', 'flex-start'],
                                '& .MuiRating-icon': {
                                    fontSize: ['3rem'],
                                    margin: '0 4px',
                                },
                                '& .MuiRating-iconFilled': {
                                    color: colors.main,
                                },
                                '& .MuiRating-iconHover': {
                                    color: colors.main,
                                },
                            }}
                        />
                    </Box>
                );
            })}
        </Box>
    );
};

export default QuestionScoreStar;
